import $ from 'jquery';
import loadingMessage from './loadingmessage.js';
const ajaxRequestManager = {
    timer: null,
    delay: 1500,
    resetTimer: function() {
        if (this.timer) {
            clearTimeout(this.timer);
            this.timer = null;
        }
    },
    isRelativeUrl: function(url) {
        return url && /^\//.test(url);
    },
    handleRequest: function(url, xhr) {
        var reset = this.resetTimer.bind(this);
        if (this.isRelativeUrl(url) && !this.disableLoadingMessage) {
            this.timer = setTimeout(function() {
                loadingMessage.show();

                xhr.always(function() {
                    loadingMessage.hide();
                    reset();
                });
            }, this.delay);

            xhr.always(reset);
        }
    },
    disableLoadingMessage: false,
    antiForgeryValidation: function(){
        $.ajaxSetup({
            beforeSend: function(xhr) {
                const isAbsoluteURI = new RegExp('^(?:[a-z]+:)?//', 'i'),
                        token = smartPak.pageData.antiForgeryToken;
    
                if (!isAbsoluteURI.test(this.url) && token) {
                    xhr.setRequestHeader('x-requestverificationtoken', token);
                }
            }
        });
    },
    init: function() {
        $.ajaxPrefilter(
            function(options, originalOptions, xhr) {
                this.handleRequest(options.url, xhr);
            }.bind(this)
        );

        this.antiForgeryValidation();
    }
};

export default ajaxRequestManager;
